import AdvanceInitContainer from "../../../../../Components/Forms&Table/Tables/DataTables/AdvanceInit/AdvanceInitContainer";

const AdvanceInit = () => {
  return <AdvanceInitContainer />;
};

export default AdvanceInit;
